const paths = {
  homePage: '/',
  kindergartenServices: '/kindergarten-services',
  govServices: '/gov-services',
  checkQueueNumber: '/check-queue-number',
  queueApplications: '/queue-applications',
  bulletinOpenPlaces: '/bulletin-open-places',
  bulletinOpenPlacesKq: '/bulletin-open-places/kqId=:kqId',
  bulletinOpenPlacesVoucher: '/bulletin-open-places/voucherId=:voucherId',
  kindergartenReestr: '/kindergarten-reestr',
  kindergartenReestrByVoucherId:
    '/kindergarten-reestr/voucherId=:voucherId&serviceProviderId=:serviceProviderId',
  kindergartenReestrByVoucherIdAndChangeDuo:
    '/kindergarten-reestr/voucherId=:voucherId&serviceProviderId=:serviceProviderId?isChangeDuo=1',
  kindergartenReestrByKindergantenId: '/kindergarten-reestr/id=:id',
  createRequestPage: '/services/create/:metadataKey',
  accountPage: '/account',
  requestsPage: '/requests',
  completedRequestsPage: '/completed-requests',
  revisionRequestsPage: '/revision-requests',
  createNewSupplierRequestPage: '/create/:from/:metadataKey/:id',
  accountSettingsPage: '/account/settings',
  attachChildWithParentPage: '/account/attach',
  viewRequestFormPage: '/view/:from/:id',
  instructionsPage: '/instructions',
  videoInstructionsPage: '/video-instructions',
  faqPage: '/faq',
  kindergartenApplications: '/kindergarten-applications',
  kindergartenAppointments: '/kindergarten-appointments',
  kindergartenNotifications: '/kindergarten-notifications',
  marketAndroidPage: '/market/android',
  voucherApplications: '/voucher-applications',
  voucherAppointments: '/voucher-appointments',
  voucherWaitingList: '/voucher-waitingList',
  myReportsPage: '/my-reports',
  myReportsHistory: '/my-reports-history',
  supplierDataChange: '/supplier-data-change',
  supplierDataChangeForm: '/supplier-data-change/id=:id',
  supplierNotifications: '/supplier-notifications',
};

export default paths;
